import { faCircleCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const copyIcons = [
  <FontAwesomeIcon icon={faCopy} />,
  <FontAwesomeIcon icon={faCircleCheck} />,
];
